export default {
    login: {
        userName: "Gebruikersnaam",
        password: "Wachtwoord",
        login: "INLOGGEN",
    },
    navbar: {
        home: "Startpagina",
        contracts: "Contracten",
        settings: "Instellingen",
        info: "Handleiding",
    },
    header: {
        home: "STARTPAGINA",
        contracts: "CONTRACTEN",
        settings: "INSTELLINGEN",
        info: "HANDLEIDING",
        contract: "CONTRACT",
        addService: "DIENST TOEVOEGEN",
        service: "DIENST",
    },
    home: {
        hello: "Hallo"
    },
    contracts: {
        active: "Actief",
        suspended: "Opgeschort",
        services: "Diensten",
        noSuspendedContracts: "Er zijn geen opgeschorte contracten",
        noServices: "Er zijn geen uitstaande serviceverleners in dit contract",
        noPressupost: "Er zijn geen uitstaande betalingen in dit contract",
        renovar: "Contract vernieuwen"
    },
    settings: {
        user: "GEBRUIKER",
        closeSession: "Sessie sluiten",
        settings: "INSTELLINGEN",
        appLanguage: "App-taal",
        confirmationText: "Weet je zeker dat je wilt uitloggen uit je sessie?",
    },
    info: {

    },
    addService: {
        addTitle: "Dienst aanvragen",
        editTitle: "Dienst",
        entrance: "Toegang tot de camping",
        exit: "Vertrek van de camping",
		pickupAtParking: "Caravan ophalen op de parkeerplaats",
		deliveryAtParking: "Caravan afleveren op de parkeerplaats",
        doneText: "Gedaan",
        cancelText: "Annuleren",
        transportDate: "Transportdatum",
        camping: "Camping",
        selectCamping: "-- Selecteer --",
        parcel: "Perceel",
        selectParcel: "Selecteer het perceel",
        save: "Opslaan",
		payment: "Betaling",
		paymentTitle: "Betaling van de dienst",
		servicePaymentConfirm: "Weet u zeker dat u wilt doorgaan met de betaling van deze dienst?",
        toastMessage: "U moet alle velden invullen om op te slaan!",

        requestService: "Deze service aanvragen",
        serviceSummary: "Serviceoverzicht",
        total: "Totaal",
		paidService: "Service betaald",
        transactionCompleted: "Transactie succesvol afgerond",
        serviceConfirm: "Weet u zeker dat u deze service wilt aanvragen?",
        loading: "Dienstverlening aanvragen...",

        reserveNum: "Reserveringsnummer",
        selectReserveNum: "Geben Sie die Nummer an",
        availableHoursInfo: "Beschikbaar transportschema: van {start} tot {end}.",

        toastMessage2: "Om binnen de komende 48 uur een dienst aan te vragen, neem contact met ons op."
    },
    service: {
        pending: "In behandeling",
        completed: "Voltooid",
        requestCompleted: "De service is correct aangevraagd"
    },
    contract: {
        entrance: "Toegang",
        exit: "Vertrek",
        registration: "Registratie",
        initialDate: "Startdatum",
        finalDate: "Einddatum",
        zone: "Zone",
        parkType: "Soort parkeerplaats",
        pendingServices: "Diensten in behandeling",
        completedServices: "Afgeronde diensten",
        pendingPressupost: "Betalingen in afwachting",
        pendingPressupostS: "Betaling in afwachting",
        pay: "Bezahlen",
        acceptConditions: "De voorwaarden en condities accepteren",
        acceptConditionsTitle: "Voorwaarden",
        contractNumberRequired: "Het is noodzakelijk om het reserveringsnummer aan te geven om transport te kunnen garanderen"
    },
    interceptors : {
        noAuthorized: "Niet-geautoriseerde gebruiker"
    },
    payment: {
        confirmed: "Betaling bevestigd",
        confirmedExtended: "De betaling is succesvol voltooid",
        article: "Artikel",
        price: "Totaal",
        informEmail: "Je ontvangt een e-mail met de betalingsgegevens",
        goBack: "Terug",
        denied: "Betaling geweigerd",
        deniedExtended: "Er is een probleem met de betaling",
        deniedInfo: "Probeer het over een paar minuten opnieuw, en als het probleem aanhoudt, neem dan contact met ons op"
    }
};
